import {
  WIDGET_ID,
  PROPERTY_ID,
  CHAT_API_URL,
} from '../config';

export const loadTawkScript = (onloadCallback: () => void): void => {
  const script = document.createElement('script');
  script.async = false;
  script.src = `${CHAT_API_URL}/${PROPERTY_ID}/${WIDGET_ID}`;
  script.charset = 'UTF-8';
  script.onload = () => { onloadCallback?.();; }
  document.body.appendChild(script);
};